import styled from "styled-components";

export const Wrapper = styled.div`
  @media (max-width: 1150px) {
    .ant-table-container {
      width: 900px;
    }
  }
  @media (max-width: 670px) {
    .header {
      display: inline-block;
      padding: 20px;
      width: 100%;
    }
    .buttons {
      margin-top: 10px;
      display: inline-block;
      width: 100%;
    }
    .deleteButton {
      margin-left: 0px;
      margin-top: 10px;
    }
    .heading {
      text-align: center;
    }
  }
`;
